

const getParentOptions = (arr) => {
    // Remove duplicates and sort by path length
    const uniqueArr = [...new Set(arr)].sort((a, b) => a.length - b.length);

    // Use a Set to keep track of paths that should be kept
    const result = [];
    const seenPaths = new Set();

    uniqueArr.forEach(path => {
        // Check if any parent path is already in the set
        let isChild = false;
        let parentPath = path;
        while (parentPath.length > 0) {
            parentPath = parentPath.substring(0, parentPath.lastIndexOf('/'));
            if (seenPaths.has(parentPath)) {
                isChild = true;
                break;
            }
        }

        if (!isChild) {
            result.push(path);
            seenPaths.add(path);
        }
    });

    return result;
}

export const getParentAndChildrenOptions = ({ data, selectedSource }) => {
    
    const selectedValues = new Set(selectedSource);

    const findNodeAndChildren = (nodes = [], parentValue = null) => {
        let parentValues = new Set();
        let childValues = new Set();

        for (const node of nodes) {
            if (!node) continue; // Skip undefined or null nodes

            if (selectedValues.has(node.value)) {
                if (node.isLeaf) {
                    // Add to children if it's a leaf node
                    childValues.add(node.value);
                } else {
                    // Add to parents and collect all children of the parent node
                    parentValues.add(node.value);
                    if (node.children && Array.isArray(node.children)) {
                        // Recursively collect all children of the parent node
                        const childResults = findNodeAndChildren(node.children, node.value);
                        childResults.childValues.forEach(value => childValues.add(value));
                    }
                }
            } else if (node.children && Array.isArray(node.children)) {
                // Recursively search in children
                const childResults = findNodeAndChildren(node.children, parentValue);
                childResults.parentValues.forEach(value => parentValues.add(value));
                childResults.childValues.forEach(value => childValues.add(value));
            }
        }

        return { parentValues, childValues };
    };

    // Get the parent and children values
    const { parentValues, childValues } = findNodeAndChildren(data);

    return {
        parents: Array.from(parentValues),
        children: Array.from(childValues)
    };
};

export default getParentOptions